var _use, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#facebook-pink_svg__path0_fill",
    fill: "#A51457"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "facebook-pink_svg__path0_fill",
    d: "M26.447 0H1.542C.692 0 0 .692 0 1.542v24.905c0 .85.692 1.543 1.542 1.543H14.95V17.152H11.3v-4.228h3.65V9.809c0-3.62 2.214-5.581 5.435-5.581 1.542 0 2.874.115 3.262.168v3.776h-2.234c-1.752 0-2.098.83-2.098 2.057v2.696h4.185l-.545 4.227h-3.64V28h7.133c.85 0 1.543-.692 1.543-1.542V1.542C27.99.682 27.308 0 26.447 0z"
  }))));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/facebook-pink-e3793e4f065d97fd9e7d3c6ba9b295d0.svg";
export { SvgFacebookPink as ReactComponent };